import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c5-five-three-one-one',
  templateUrl: './c5-five-three-one-one.component.html',
  styleUrls: ['./c5-five-three-one-one.component.scss']
})
export class C5FiveThreeOneOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
